export default "__VITE_ASSET__DRhbvcOP__"